import { z } from 'zod';
// import { PASSWORD_REGEX } from '@/utils/regex.utils';
import i18next from 'i18next';

export const loginSchema = z.object({
  email: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailRequired'),
      });
    } else if (!z.string().email().safeParse(data).success) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:emailFormatIncorrect'),
      });
    }
  }),
  password: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('common:passwordRequired'),
      });
    }
    // else if (!PASSWORD_REGEX.test(data)) {
    //   ctx.addIssue({
    //     code: z.ZodIssueCode.custom,
    //     message: i18next.t('common:passwordFormatIncorrect'),
    //   });
    // }
  }),
});

export type TLoginSchema = z.infer<typeof loginSchema>;
